import { useReduxState } from "../../explorer/redux/hooks";
import { Site } from "../../explorer/types/SpareParts";
import { reduxStoreConfig } from "../configuration/reduxStoreConfig";
import useCurrentSite from "./useCurrentSite";

export const useOfferOrder: () => {
    minTwoChars:(x: number) => string;
    makeOfferReference:() => string;
} = () => {

    const [currentSite, setCurrentSite] = useCurrentSite();
    const minTwoChars = (x: number) => {
        if (("" + x).length == 2) return "" + x;
        return "0" + x;
    };

    const makeOfferReference = () => {
        var now = new Date();
        return (
            currentSite?.customerCode +
            "_" +
            (now.getFullYear() - 2000) +
            minTwoChars(now.getMonth() + 1) +
            minTwoChars(now.getDate()) +
            minTwoChars(now.getHours()) +
            minTwoChars(now.getMinutes()) +
            minTwoChars(now.getSeconds())
        );
    };


    return { makeOfferReference, minTwoChars };
};